'use client';
import {memo, useEffect, useState} from 'react';
import Link from 'next/link';
import {cn} from '@/app/utils/CN';
import MoonIcon from '@/components/icons/MoonIcon';
import SunIcon from '@/components/icons/SunIcon';
import ShipIcon from '@/components/icons/ShipIcon';
import MobileNavigation from '@/components/navigation/MobileNavigation';
import {NavigationItems} from '@/components/navigation/NavigationItems';

const Header = () => {
  const [activeScroll, setActiveScroll] = useState(false);

  const listenScrollEvent = () => {
    const newValue = window.scrollY > 30;
    setActiveScroll(() => newValue);
  };

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
    return () => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
  }, []);

  const toggleTheme = () => {
    document.documentElement.classList.toggle('dark');
  };

  return (
    <>
      <header
        className={cn(
          'sticky top-0 flex items-center justify-between gap-2 py-5 px-5 bg-opacity-0 z-[100]',
          'shadow shadow-primary dark:shadow-secondary-dark',
          {
            'bg-primary dark:bg-secondary-dark bg-opacity-100 transition-all ease-in-out duration-500':
              activeScroll,
          }
        )}
      >
        <Link
          href={'/'}
          className={cn(
            'flex flex-row gap-2 items-center group rounded-full p-1 hover:bg-transparent',
            'xl:hover:bg-primary xl:dark:hover:bg-secondary-dark',
            {
              'xl:hover:bg-secondary xl:dark:hover:bg-primary': activeScroll,
            }
          )}
        >
          <ShipIcon
            width={activeScroll ? 40 : 60}
            height={activeScroll ? 40 : 60}
            className={cn(
              'fill-primary dark:fill-secondary-dark group-hover:fill-primary dark:group-hover:fill-secondary-dark xl:group-hover:fill-secondary xl:dark:group-hover:fill-primary',
              {
                'fill-secondary dark:fill-primary xl:group-hover:fill-primary xl:dark:group-hover:fill-secondary-dark':
                  activeScroll,
              }
            )}
          />

          <h1
            className={cn(
              'text-2xl md:text-4xl',
              'text-primary dark:text-secondary-dark group-hover:text-primary dark:group-hover:text-secondary-dark xl:group-hover:text-secondary xl:dark:group-hover:text-primary',
              {
                'text-secondary dark:text-primary-dark xl:group-hover:text-primary xl:dark:group-hover:text-secondary-dark':
                  activeScroll,
              }
            )}
          >
            Low price
          </h1>
        </Link>
        <nav className={'hidden xl:flex items-center gap-5'}>
          {NavigationItems.map((item, index) => (
            <Link
              key={index}
              href={item.href}
              className={cn(
                'text-xl xl:text-3xl px-5 py-2 rounded-2xl',
                'text-primary hover:bg-primary hover:text-secondary dark:text-secondary-dark dark:hover:bg-secondary-dark dark:hover:text-primary',
                {
                  'text-xl text-secondary hover:bg-secondary hover:text-primary dark:text-primary-dark dark:hover:bg-primary dark:hover:text-secondary-dark':
                    activeScroll,
                }
              )}
            >
              {item.name}
            </Link>
          ))}
        </nav>
        <button
          className="flex w-[5.5rem] items-center rounded-full bg-black dark:bg-white shadow transition duration-300 focus:outline-none"
          onClick={toggleTheme}
        >
          <div
            className={cn(
              'relative flex size-12 transform items-center rounded-full p-1 transition duration-500',
              '-translate-x-1 bg-white dark:translate-x-full dark:bg-black'
            )}
          >
            <span className={cn('rounded-full bg-white p-1 block dark:hidden')}>
              <SunIcon className={'stroke-black'} />
            </span>
            <span className={cn('rounded-full bg-black p-1 hidden dark:block')}>
              <MoonIcon className={'fill-white'} />
            </span>
          </div>
        </button>
      </header>
      <MobileNavigation />
    </>
  );
};

export default memo(Header);
